import "./recordLine.css";

const RecordLine = ({
  width,
  number,
  icon,
  numberColor,
  percentage,
  percentageText,
  firstLine,
  secondLine,
  thirdLine,
  secondNumber,
  actions
}) => {
  // console.debug("secondNumber", secondNumber);
  // console.debug("actions", actions);
  return (
    <div className="record-line" style={width ? { width: `${width}rem` } : {}}>
      <p className="first-line">{firstLine}</p>
      <p className="second-line">{secondLine}</p>
      <p className="third-line">{thirdLine}</p>
      <div className="fourth-line">
        <p className="number" style={{ color: numberColor }}>
          {number}
          {secondNumber > 0 && ` of ${secondNumber}`}
          {actions && secondNumber === 0 && ` of 0`}
        </p>
        <span className="icon">{icon}</span>
      </div>
      <div className="fifth-line">
        <p className="percentage">
          {/* <span className="percentage-first">{percentage}%</span>{" "}
          <span className="percentage-second">{percentageText}</span> */}
        </p>
      </div>
    </div>
  );
};

export default RecordLine;
